var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFinishedStep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 42C32.598 42 42 32.598 42 21C42 9.40202 32.598 0 21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42Z",
    fill: "#DDD7CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9991 21.1694L36.439 15.6094L33.8862 17.2785L20.9998 4.39209L18.1248 20.3187L5.56055 15.6094L16.8586 26.9075L11.4579 33.7594L19.6561 41.9576C20.1004 41.9856 20.5485 41.9999 20.9998 41.9999C32.5412 41.9999 41.908 32.6893 41.9991 21.1694Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 4.39209L25.7708 14.0591L36.4391 15.6094L28.7194 23.1341L30.5418 33.7593L20.9998 28.7427L11.4579 33.7593L13.2802 23.1341L5.56055 15.6094L16.2288 14.0591L20.9998 4.39209Z",
    fill: "#E4E4E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 28.7458V28.7427L30.542 33.7593L28.7196 23.1341L36.4393 15.6094L25.771 14.0591L21 4.39209V28.7458Z",
    fill: "#CBCBCB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 4.39209V19.6206L36.4393 15.6094L25.771 14.0591L21 4.39209Z",
    fill: "#B8B8B8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5429 33.7593L21.0009 19.6206L11.459 33.7593L21.0009 28.7427L30.5429 33.7593Z",
    fill: "#C9C9C9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.542 33.7593L21 19.6206V19.6291V28.7458V28.7427L30.542 33.7593Z",
    fill: "#B8B8B8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2288 14.0591L5.56055 15.6094L20.9998 19.6206V4.39209",
    fill: "#F4F4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFinishedStep);
export default __webpack_public_path__ + "static/media/not_finished_step.800c3ff9ba68bfe6afc88149e22762e1.svg";
export { ForwardRef as ReactComponent };